import {
  Component,
  ChangeDetectionStrategy,
  OnInit,
  inject,
  PLATFORM_ID,
  ChangeDetectorRef,
} from "@angular/core";
import {
  FormArray,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";

import { CommonModule, DatePipe, isPlatformServer } from "@angular/common";

import {
  TuiAlertService,
  TuiButton,
  TuiIcon,
  TuiLabel,
  TuiLink,
  TuiTitle,
} from "@taiga-ui/core";
import {
  TuiProgressBar,
  TuiFieldErrorPipe,
  TuiCheckbox,
  TuiFilterByInputPipe,
  TuiFiles,
} from "@taiga-ui/kit";

import {
  TuiError,
  TuiDataList,
  TuiAppearance,
  TuiRoot,
  TuiTextfield,
  TuiDropdown,
} from "@taiga-ui/core";
import {
  TuiDataListWrapper,
  TuiRadio,
  TuiAvatar,
  TuiBadge,
  TuiItemsWithMore,
  TuiProgress,
  TuiBadgedContent,
  TuiTabs,
  TuiInputNumber,
} from "@taiga-ui/kit";

import {
  TuiInputDateModule,
  TuiInputModule,
  TuiInputPhoneModule,
  TuiInputSliderModule,
  TuiInputTimeModule,
  TuiSelectModule,
  TuiTextfieldControllerModule,
  TuiTextareaModule,
  TuiInputTagModule,
  TuiComboBoxModule,
  TuiMultiSelectModule,
  TuiInputDateTimeModule,
  TuiInputNumberModule,
} from "@taiga-ui/legacy";

import { TUI_IS_E2E, TuiDay } from "@taiga-ui/cdk";
import { AsyncPipe } from "@angular/common";
import { of, timer, takeWhile, share, repeat, map, timeout, catchError, throwError } from "rxjs";
import { NG_EVENT_PLUGINS } from "@taiga-ui/event-plugins";
import { Router } from "@angular/router";
import { Meta, Title } from "@angular/platform-browser";
import { environment } from "../../../../environments/environment";
import { ProgramService } from "../../../services/program.service";
import { NgxSpinner, NgxSpinnerService } from "ngx-spinner";
import { ClowderService } from "../../../services/clowder.service";
import { ClowderfrontUrl } from "../../../storan-constant";
import { AuthService } from "../../../services/auth.service";

@Component({
  selector: 'app-end-of-season-survey',
  standalone: true,
  imports: [ReactiveFormsModule,
    CommonModule,
    AsyncPipe,
    TuiProgressBar,
    TuiButton,
    TuiDropdown,
    TuiLabel,
    TuiFieldErrorPipe,
    TuiError,
    TuiDataList,
    TuiAppearance,
    TuiRadio,
    TuiInputDateModule,
    TuiTextfield,
    TuiTextfieldControllerModule,
    TuiInputModule,
    TuiInputNumber,
    TuiInputPhoneModule,
    TuiInputTimeModule,
    TuiSelectModule,
    TuiTextareaModule,
    TuiCheckbox,
    TuiAvatar,
    TuiInputTagModule,
    TuiIcon,
    TuiProgress,
    TuiFilterByInputPipe,
    TuiFiles,
    TuiComboBoxModule,
    TuiMultiSelectModule,
    TuiBadgedContent,
    TuiDataListWrapper,
    TuiInputNumberModule,
    TuiInputSliderModule,
    TuiTextfieldControllerModule,
    TuiItemsWithMore,
    TuiTabs,
    FormsModule,
    TuiTitle,
    TuiInputDateTimeModule,
    TuiLink,
    TuiRoot],
  templateUrl: './end-of-season-survey.component.html',
  styleUrl: './end-of-season-survey.component.css',
  //changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [NG_EVENT_PLUGINS,DatePipe]
})
export class EndOfSeasonSurveyComponent {
  currentSurveyStep: number = 5;
  currentSurveyInnerStep: number = 1;
  currentSatisfactionStep: number = 1;
  currentStep: number = 1;
  firstPage: number = 1;
  current_upload_inner_step: number = 1;
  currentSeasonSurveyStep: number = 1;
  emailAddress: any;
  trialId: any;
  dataSetId: any;
  growerDetails: any;
  growerid: any;
  noImageAssets: any;
  uploadImageId: any; 
  endOfSeasonSurveyStatus: any;
  applicationLockSatus: any;
  satisfactionSurveyStatus: any;
  cleanRowPhotosStatus: any;
  additionalCommentsLength:number =0;
  additionalFeedBackLength:number =0;
  
  constructor(private router: Router, private meta: Meta, private title: Title, private programService: ProgramService, private spinner: NgxSpinnerService,
    private cdr: ChangeDetectorRef, private _clowderService: ClowderService, private datepipe: DatePipe,private authService:AuthService) {
    this.title.setTitle("End-of-Season Survey");
    this.meta.updateTag({ name: 'description', content: '' })
  }
  private readonly alerts = inject(TuiAlertService);
  // ngAfterViewInit() {
  //   setTimeout(() => {
  //     document.querySelector('#endOfSeason')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
  //   },600);
  // }
  ngOnInit(): void {
    this.authService.checkAuthAndRedirect();
    this.emailAddress = localStorage.getItem("email");
    this.getGrowerDetails();
    let dataSets = JSON.stringify(environment.ClowderConfig.datasets.find(item => Object.keys(item).includes('Corn-field')));
     this.dataSetId = JSON.parse(dataSets)['Corn-field'];
    //this.dataSetId = '67781d76a33165e4f81d1bab';
    this.endOfSeasonSurveyStatus = sessionStorage.getItem("endOfSeasonSurveyStatus") ? sessionStorage.getItem("endOfSeasonSurveyStatus") : "";
    if (this.endOfSeasonSurveyStatus === 'COMPLETED' || this.endOfSeasonSurveyStatus === 'LOCK' || this.endOfSeasonSurveyStatus=='GETSTARTEDDISABLE' || !this.endOfSeasonSurveyStatus) {
      this.router.navigate(['/program']);
    }

  this.seasonSurveyForm.get('additionalCommentsAboutStorenExperience')?.valueChanges.subscribe((value)=>{
    this.additionalCommentsLength = value?.length ?? 0;
  })
  this.seasonSurveyForm.get('additionalFeedbackForStorenProgram')?.valueChanges.subscribe((value)=>{
    this.additionalFeedBackLength = value?.length ?? 0;
  })
  
  
  }
  characValidation(value:any):boolean{
    if(value.length>=1000){
      return false;
    }
    return true;
  }
  charSubstring(value: any, index: any) {
    if (index == 'additionalCommentsAboutStorenExperience') {
      if (value && value.length > 1000) {
        value = value.substring(0, 1000)
        this.seasonSurveyForm.get('additionalCommentsAboutStorenExperience')?.setValue(value);
      }
    } else if (index == 'additionalFeedbackForStorenProgram') {
      if (value && value.length > 1000) {
        value = value.substring(0, 1000)
        this.seasonSurveyForm.get('additionalFeedbackForStorenProgram')?.setValue(value);
      }
    }
  }
  getGrowerDetails() {
    this.programService.getgrowerdetailsbyEmailId(this.emailAddress).subscribe((res: any) => {
      this.growerDetails = JSON.parse(res);
      if (this.growerDetails.length > 0) {
        this.growerid = this.growerDetails[0].GROWER_ID;
        this.trialId =  this.trialId = this.growerDetails[0].trail_id == null ? this.generateTrialId(this.growerDetails[0]) : this.growerDetails[0].trail_id;
      }
    })
  }
  generateTrialId(growerDetails: any) {
    const CU = growerDetails['CU_Description'];
    const growerLastName = growerDetails['USER_LAST_NAME'];
    const randomSixDigitNumber = Math.floor(100000 + Math.random() * 900000);
    const year = new Date().getFullYear();
    return `${CU}_${growerLastName}_${randomSixDigitNumber}_${year}`;
  };
  async submitEndOfSeasonSurvey() {
    if (this.seasonSurveyForm.valid) {
      if (this.growerDetails[0].trail_id == null || this.growerDetails[0].trail_id == "") {
        const trialdetails =
        {
          "TrialId": this.trialId,
          "TrialType": "SSP",
          "GrowerId": this.growerid,
          "Crop": "Corn (field)",
          "NoOfTreatments": 1,
          "treatments": [""],
          "TreatmentName": [""],
          "NoOfReplication": 1,
          "GeoLatitude": "0.000000",
          "GeoLongitude": "0.000000",
          "AddressLine1": this.growerDetails ? this.growerDetails[0]['USER_ADDRESS1'] : "",
          "AddressLine2": this.growerDetails ? this.growerDetails[0]['USER_ADDRESS2'] : "",
          "City": this.growerDetails ? this.growerDetails[0]['USER_CITY'] : "",
          "State": this.growerDetails ? this.growerDetails[0]['USER_STATE'] : "",
          "ZipCode": this.growerDetails ? this.growerDetails[0]['USER_POSTAL_CODE'] : "",
          "TrialTreatments": "",
          "FieldDescription": "",
          "UpdatedBy": this.emailAddress,
          "TreatmentName1": ""
        };
        await this.programService.trialRegistration(trialdetails).subscribe((response) => {
          if (response > 0) {
          } else {
            this.spinner.hide();
            this.alerts.open('<strong>Something went wrong</strong>', { label: 'Error!', appearance: 'negative', autoClose: 1000 }).subscribe();
          }
        });
      }

      await this.uploadDefaultNoImage();
      // let saveSeasonSurveyObj = {
      //   "GrowerId": this.growerid,
      //   "TrailId": this.trialId,
      //   "ProgramScheduleId": 4,
      //   "Programstatus": "Completed"
      // }
      // this.spinner.show();
      // this.programService.insertprogramdetails(saveSeasonSurveyObj).subscribe(async () => {
      //   await this.uploadDefaultNoImage();
      //   // this.currentSurveyInnerStep = 2;
      //   // this.spinner.hide();
      // }, (error) => {
      //   this.spinner.hide();
      //   console.error('Error saving API :', error);
      // });
    }
   // this.router.navigate(["/program-complete"])
  }

  updateStatusDB(){
    let saveSeasonSurveyObj = {
      "GrowerId": this.growerid,
      "TrailId": this.trialId,
      "ProgramScheduleId": 4,
      "Programstatus": "Completed"
    }
    this.spinner.show();
    this.programService.insertprogramdetails(saveSeasonSurveyObj).subscribe(async () => {
      //  this.spinner.hide();
    }, (error) => {
      this.spinner.hide();
      console.error('Error saving API :', error);
    });
  }
  private async uploadDefaultNoImage(): Promise<void> {
    try {
      this.spinner.show();
      // const id = crypto.randomUUID();
      // Create and upload new no-image asset
      const response1 = await fetch('No-image.png');
      const blob = await response1.blob();
      const uniquenumber = Date.now();
      //  const fileName = `No-Image_${uuidv4().substr(0, 6)}.png`;
      const fileName = `No-Image_${uniquenumber}.png`;
      const file = new File([blob], fileName, { type: blob.type });

      const formDatas = new FormData();
      formDatas.append('type', 'file');
      formDatas.append('path', `/${fileName}`);
      formDatas.append('file', file, fileName);
      this.noImageAssets = ClowderfrontUrl + 'Corn-field/' + fileName;
      new Promise((resolve, reject) => {
        this._clowderService.uploadImage(formDatas, this.dataSetId )
          .pipe(
            timeout(90000),
            catchError(error => {
              this.handleError(error, 'Error uploading no-image asset');
              this.errorCaptureDB(error,'Error uploading no-image asset');
              reject(error);
              return throwError(() => error);
            })
          )
          .subscribe({
            next: (res) => {
              if (res['id'] !== '') {
                // this.spinnerContent = "Uploading Metadata";
                // this.spinnerPercentage = 60;
                this.uploadImageId = res['id'];
                resolve(this.uploadImageMetadata(res['id']));
              }
            },
            error: (error) => reject(error)
          });
      });
      //this.current_step = 2;
      this.cdr.detectChanges();

    } catch (error) {
      console.error('Error uploading no-image asset:', error);
      throw error;
    }
  }



  convertToDate(tuiDay: TuiDay): string {
    if (tuiDay === null || tuiDay === undefined) {
      return '';
    }
    const date = new Date(tuiDay.year, tuiDay.month, tuiDay.day);
    return date.toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' });
  }
  async uploadImageMetadata(fileId: any) {
    this.spinner.show();
    const SubmittedOn = this.datepipe.transform(new Date(), 'MM/dd/yyyy HH:mm:ss')
    // const SubmittedOn = new Date().toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' });
    let noImageFilename = this.noImageAssets.split('/')[4];
    let saveSatisfactionSurveyObject = {
      "MS-Trial Type": "SSP",
      "MS-Trial ID": this.trialId,
      "MS-Asset-url": this.noImageAssets,
      "MS-SubmittedOn": SubmittedOn,
      "MS-Asset File Name": noImageFilename,
      "MS-CU Role": this.growerDetails[0]['CU_Description'],
      "MS-Crop": "Corn (field)",
      "MS-Product Type": "Herbicide",
      "MS-Product": "Storen",
      "MS-Asset Type": "No-Image",
      "MS-Submitter Email": this.emailAddress,
      "MS-Program Status": "End-of-Season Survey",
      "MS-End-of-Season Survey": {
        "MS-Planning to use storen": this.seasonSurveyForm.value.planToUseStorenNextSeason,
        "MS-Rrecommend Storen to other growers": this.seasonSurveyForm.value.recommendStorenToOtherGrowers,
        "MS-Satisfied with Storen":this.seasonSurveyForm.value.satisfactionWithStorenVsPreviousHerbicide,
        "MS-Other Comments":this.seasonSurveyForm.value.additionalCommentsAboutStorenExperience,
         "MS-Rate the amount of communication":this.seasonSurveyForm.value.communicationRatingForStorenProgram,
         "MS-How Easy to Participate":this.seasonSurveyForm.value.easeOfParticipationInStorenProgram,
         "MS-Rate for Earned Throughout":this.seasonSurveyForm.value.ratingForStorenRewards,
         "MS-Satisfied Overall" :this.seasonSurveyForm.value.overallSatisfactionWithStorenProgram,
         "MS-Comments for Satisfaction Experience":this.seasonSurveyForm.value.additionalFeedbackForStorenProgram,
         "MS-Reward":this.seasonSurveyForm.value.selectedRewardOption
      },

     "MS-SU Approval Status": "Pending",
      "MS-SU Approved or Rejected Date": "",
      "MS-SU Approved or Rejected by": "",
      "MS-SU Comments": "",
      "MS-Legal Approval Status": "Pending",
      "MS-Legal Approved or Rejected Date": "",
      "MS-Legal Comments": "",
      "MS-Legal Approved or Rejected by": ""

    }

    return this._clowderService.uploadImageMetadata(fileId, saveSatisfactionSurveyObject, this.emailAddress)
      .pipe(
        catchError(error => {
          this.handleError(error, `Error uploading metadata for ${this.noImageAssets}`);
          this.errorCaptureDB(error, `Error uploading metadata for ${this.noImageAssets}`);
          // this.spinnerPercentage = 0;
          // this.spinnerContent = "Loading";
          this.spinner.hide();
          return throwError(() => error);
        })
      )
      .subscribe({
        next: (res) => {
          this.updateStatusDB();
          this.spinner.hide();
          sessionStorage.setItem("endOfSeasonSurveyStatus", "COMPLETED");
          this.applicationLockSatus = sessionStorage.getItem("applicationLockSatus");
          this.satisfactionSurveyStatus = sessionStorage.getItem("satisfactionSurveyStatus");
          this.cleanRowPhotosStatus = sessionStorage.getItem("cleanRowPhotosStatus");
          this.endOfSeasonSurveyStatus = sessionStorage.getItem("endOfSeasonSurveyStatus");
          if(this.endOfSeasonSurveyStatus == 'COMPLETED' && this.cleanRowPhotosStatus == 'COMPLETED' && this.satisfactionSurveyStatus == 'COMPLETED' && this.applicationLockSatus == 'COMPLETED'){
            this.router.navigate(['/program-complete']).then(()=>{
              window.scrollTo({top:0,behavior:'smooth'});
            });
            // this.currentStep = 6;
          }else{
            setTimeout(() => {
              document.querySelector('#seasonThanks')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
            },600)
            this.currentSeasonSurveyStep = 2;
          }
          if (!res) {
            // this.spinnerPercentage = 0;
            // this.spinnerContent = "Loading";
            // this.currentSurveyInnerStep = 2;
            // this.spinner.hide();
          }
        },
        error: (error) => {
          // this.spinnerPercentage = 0;
          // this.spinnerContent = "Loading";
          this.spinner.hide();
          this.errorCaptureDB(error, `Error uploading metadata for ${this.noImageAssets}`);
          this.handleError(error, `Error uploading metadata for ${this.noImageAssets}`);
        }
      });
  }

  private handleError(error: any, customMessage: string = 'An error occurred'): void {
    console.error('API Error:', error);
    this.spinner.hide();
    this.alerts.open(customMessage, {
      label: 'Error!',
      appearance: 'error',
      autoClose: 5000
    }).subscribe();
  }
  returnToMainDashboard() {
    this.currentSurveyStep = 1;
    this.currentStep = 1;
    this.firstPage = 1;
    this.router.navigate(['/program']).then(()=>{
      window.scrollTo({top:0,behavior:'smooth'});
    })
  }
  errorCaptureDB(error:any,errorMsgs:any){
    let newVar = this.stripHtmlTags(error.error);
    let textLog = 'GrowerId:'+this.growerid+','+'Email:'+this.emailAddress+','+"Program:End-of-Season,Message="+error.message+"Error:"+newVar;  
    this.programService.errorDetailsLog(textLog, errorMsgs).subscribe(res => {
    }, (error) => {
      console.error('Error saving dataloop API :', error);
    });

  }
  private stripHtmlTags(html: string): string {
    if (typeof html !== 'string') return '';
    return html.replace(/<[^>]*>/g, '').replace(/\n/g, ' ').trim();
  }

  protected seasonSurveyForm = new FormGroup({
    applyDate: new FormControl(new TuiDay(2017, 2, 15)),
    planToUseStorenNextSeason: new FormControl("", Validators.required),
    recommendStorenToOtherGrowers: new FormControl("", Validators.required),
    satisfactionWithStorenVsPreviousHerbicide: new FormControl(
      ""
    ),
    additionalCommentsAboutStorenExperience: new FormControl(
      "",Validators.minLength(50)
    ),
    communicationRatingForStorenProgram: new FormControl(
      "",
      Validators.required
    ),
    easeOfParticipationInStorenProgram: new FormControl(
      "",
      Validators.required
    ),
    ratingForStorenRewards: new FormControl("", Validators.required),
    overallSatisfactionWithStorenProgram: new FormControl(
      "",
      Validators.required
    ),
    additionalFeedbackForStorenProgram: new FormControl(
      "",Validators.maxLength(1000)
    ),
    selectedRewardOption: new FormControl("",
      Validators.required),
  });
}
